import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'DCO-file-upload',
  template: `
  <div class="d-flex">
      <button class="btn btn-outline-primary fw-semibold text-sm m-0" (click)="fileUpload.click()">
        <i class="fa-solid fa-arrow-up-from-bracket fa-lg me-2"></i>
          {{"DCO.ComponentFileUpload_AddFile" | translate}}
        </button>        
      <input type="file" class="d-none" (change)="onFileSelected($event)" #fileUpload>
      <div class="py-2 ps-3 mt-1">
        {{fileName || ("DCO.ComponentFileUpload_NoFileSelected" | translate)}}
      </div>  
      <small *ngIf="componentFileSizeErrorMessage" class="text-danger fw-semibold mt-1 d-block">
        {{ "DCO.File_SizeError" | translate }}
      </small> 
      <small *ngIf="componentFileExtensionErrorMessage" class="text-danger fw-semibold mt-1 d-block">
        {{ "DCO.File_ExtensionError" | translate }}
      </small> 
  </div>
`  ,
  standalone: false,
})

export class FileUploadComponent {
  @Output() fileSelected = new EventEmitter<File | null>();

  fileName: string = '';
  componentFileSizeErrorMessage: boolean = false;
  componentFileExtensionErrorMessage: boolean = false;
  uploadedFile: File | null = null;

  onFileSelected(event: Event): void {
    this.componentFileSizeErrorMessage = false;
    this.componentFileExtensionErrorMessage = false;
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file: File = input.files[0];

      // 1. Validar Tamaño Máximo (10MB)
      const maxSizeInBytes = 10 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        this.resetFileState(input);
        this.componentFileSizeErrorMessage = true;
        return;
      }

      const allowedExtensions = ['pdf', 'docx', 'doc', 'jpg', 'jpeg', 'png'];
      const fileExtension = file.name.split('.').pop()?.toLowerCase();

      if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
        this.resetFileState(input);
        this.componentFileExtensionErrorMessage = true;
        return;
      }

      this.fileName = file.name;
      this.uploadedFile = file;
      this.componentFileSizeErrorMessage = false;
      this.componentFileExtensionErrorMessage = false;
      this.fileSelected.emit(file);

    } else {
      this.resetFileState(input);
    }
  }

  private resetFileState(input: HTMLInputElement): void {
    this.componentFileSizeErrorMessage = false;
    this.componentFileExtensionErrorMessage = false;
    this.fileName = '';
    this.uploadedFile = null;
    input.value = '';
    this.fileSelected.emit(null);
  }

  clearFileSelection(): void {
    this.fileName = '';
    this.uploadedFile = null;
    this.componentFileSizeErrorMessage = false;
    this.componentFileExtensionErrorMessage = false;
    this.fileSelected.emit(null);
  }
}